import { Plugin } from 'prosemirror-state';

import { AddMenuFlashcard, Callout as CalloutIcon } from '@lyearn/icons';
import { EditorOptions } from '@lyearn/lygo-core';

import { addMenuItemType } from '../../../types/menus';
import { addAddMenuBlock } from '../../../utils/menus';
import { NODE_NAME } from '../consts';
import FlashCardNodeView from './NodeView';

function plugins({ createReactNodeView, t }: EditorOptions) {
  return [
    new Plugin({
      props: {
        nodeViews: {
          [NODE_NAME]: (node, view, getPos, decorations) => {
            return createReactNodeView({
              node,
              view,
              getPos,
              decorations,
              component: FlashCardNodeView,
              stopDomEvents: true,
            });
          },
        },
      },
    }),

    new Plugin({
      view: (editorView) => {
        addAddMenuBlock(editorView, [
          {
            name: NODE_NAME,
            title: t('Lygo:Menu.flash_card.title') as string,
            icon: CalloutIcon,
            addMenuIcon: AddMenuFlashcard,
            addMenuItemType: addMenuItemType.interactive_blocks,
            description: t('Lygo:Menu.flash_card.description') as string,
            searchWords: ['flashcard', 'text', 'interactive'],
          },
        ]);
        return {};
      },
    }),
  ];
}

export default plugins;
